import CryptoJS from 'crypto-js';
import moment from 'moment';

export const buildIntercomBootSettings = (userMaster, secretKey) => {
  let interComObj = {
    api_base: 'https://api-iam.intercom.io',
    app_id: 'ogob6jks',
    custom_launcher_selector: '.intercom-chatbot-toggle'
  };

  if (!userMaster) {
    return interComObj;
  }

  interComObj.name = `${userMaster.FirstName} ${userMaster.LastName}`;
  interComObj.email = userMaster.Email;
  interComObj.created = moment(userMaster.Created).unix();
  interComObj.user_id = userMaster.GUID;

  if (secretKey && userMaster.GUID) {
    const userIdentifier = userMaster.GUID.toString();
    const hash = CryptoJS.HmacSHA256(userIdentifier, secretKey).toString(
      CryptoJS.enc.Hex
    );

    interComObj.user_hash = hash;
    interComObj.hash = hash;
  }

  return interComObj;
};

export const callIntercom = (...args) => {
  if (typeof window !== 'undefined' && typeof window.Intercom === 'function') {
    window.Intercom(...args);
  }
};
